/* eslint-disable @typescript-eslint/ban-ts-comment */
import i18n from '@seller-hermes/i18n/config';
import { QueryClient } from 'react-query';
import { getRouter } from './routes';
import { createStoreWithInjections, storeModel } from '../store/root.store';
const { NX_ENV: env } = process.env;

// const isLocalOrStorybook = env === 'LOCAL' || isStorybook;

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchInterval: false,
      refetchOnWindowFocus: false,
      refetchIntervalInBackground: false,
    },
  },
});

export const posthogApiKey = process.env['NX_POSTHOG_KEY'] ?? '';
export const posthogOptions = process.env['NX_POSTHOG_HOST']
  ? { api_host: process.env['NX_POSTHOG_HOST'] }
  : undefined;

(async () => {
  try {
    if (!window.ResizeObserver) {
      window.ResizeObserver = (
        await import('resize-observer-polyfill')
      ).default;
    }
  } catch (err: any) {
    console.error(err);
  }
})();

export const store = createStoreWithInjections({
  intl: i18n,
  queryClient,
});

// NÃO chamar store.getActions().start() aqui: essa chamada dispara o GET /me
// que popula state.user (tema, sellers, permissions — tudo que a sidebar lê).
// Rodar aqui, fora do fluxo de rota, corre contra bootstrapDashboardContext()
// (só chamado dentro dos loaders) — como getValidActiveSellerGroupId() falha
// fechado (retorna null) até o bootstrap registrar os candidatos válidos
// (LOG-475), esse /me sai sem X-Active-Seller-Group. E como start() vira
// no-op depois de isStarted=true (login.store.ts), essa primeira resposta
// mal-escopada fica congelada em state.user pro resto da sessão — os loaders
// de rota (que fazem bootstrap → start() na ordem certa) não corrigem mais.
// Cada loader de rota já chama start() no momento certo por conta própria.
export const router = getRouter(store);
